export const en = {
  "nav.inbox": "Inbox",
  "nav.today": "Today",
  "nav.upcoming": "Upcoming",
  "nav.anytime": "Anytime",
  "nav.someday": "Someday",
  "nav.logbook": "Logbook",
  "nav.assigned": "Assigned to me",

  "section.projects": "Projects",
  "section.thisEvening": "This Evening",

  "empty.inbox": "Inbox zero.",
  "empty.today": "All clear.",
  "empty.upcoming": "Nothing scheduled.",
  "empty.anytime": "Nothing waiting.",
  "empty.someday": "No someday ideas yet.",
  "empty.logbook": "Nothing logged yet.",
  "empty.assigned": "Nothing assigned to you.",
  "empty.project": "Nothing here yet.",

  "sync.synced": "Synced",
  "sync.syncing": "Syncing…",
  "sync.offline": "Offline — saved locally",
  "sync.error": "Sync failed",
  "sync.rejected": "{n} change(s) were rejected by the server and have been undone.",

  "quickadd.placeholder": "Add a task — try dates, #project, @label, !p1",
  "quickadd.hint": "Enter to add · Esc to close",
  "quickadd.add": "Add task",

  "toolbar.search": "Search",

  "detail.notes": "Notes",
  "detail.notesPlaceholder": "Add notes…",
  "detail.startDate": "Start date",
  "detail.evening": "This evening",
  "detail.deadline": "Deadline",
  "detail.priority": "Priority",
  "detail.labels": "Labels",
  "detail.project": "Project",
  "detail.section": "Section",
  "detail.someday": "Someday",
  "detail.delete": "Delete task",
  "detail.recurrence": "Repeats",
  "detail.noProject": "Inbox",
  "detail.noSection": "No section",
  "detail.datePlaceholder": "e.g. tomorrow, next tue, 31.7.",
  "detail.clear": "Clear",
  "detail.reminder": "Remind me",
  "detail.reminderPlaceholder": "e.g. tomorrow 9am",
  "detail.reminderClear": "Clear reminder",
  "detail.assignee": "Assignee",
  "detail.assignNobody": "Nobody",
  "detail.assignMe": "Assign to me",
  "detail.metaCreated": "Created",
  "detail.metaChanged": "Changed",
  "detail.metaCompleted": "Completed",

  "detail.fullscreen": "Open full screen",

  "fullscreen.close": "Close full screen",
  "fullscreen.noNotes": "No notes.",
  "fullscreen.notFound": "This task isn't in this workspace.",

  "assign.me": "Me",

  "comments.title": "Comments",
  "comments.empty": "No comments yet.",
  "comments.placeholder": "Write a comment…",
  "comments.hint": "Enter to send · Shift+Enter for a new line",
  "comments.send": "Send",
  "comments.edit": "Edit comment",
  "comments.delete": "Delete comment",
  "comments.save": "Save",
  "comments.edited": "edited",
  "comments.deleteConfirm": "Delete this comment?",

  "attachment.title": "Attachments",
  "attachment.add": "Add attachment",
  "attachment.delete": "Delete attachment",
  "attachment.deleteConfirm": "Delete this attachment?",
  "attachment.uploadError": "Upload failed. Check your connection and file size.",
  "attachment.downloadError": "Download failed. Check your connection.",

  "time.justNow": "just now",

  "priority.none": "None",
  "priority.p1": "P1",
  "priority.p2": "P2",
  "priority.p3": "P3",

  "settings.title": "Settings",
  "settings.account": "Account",
  "settings.appearance": "Appearance",
  "settings.workspace": "Workspace",
  "settings.members": "Members",
  "settings.notifications": "Notifications",
  "settings.mcp": "Claude / MCP",
  "settings.name": "Name",
  "settings.locale": "Language",
  "settings.theme": "Theme",
  "settings.logout": "Log out",
  "settings.save": "Save",

  "palette.placeholder": "Search tasks, projects, or type a command…",
  "palette.groupTasks": "Tasks",
  "palette.groupProjects": "Projects",
  "palette.groupLabels": "Labels",
  "palette.groupCommands": "Commands",
  "palette.empty": "No matches.",
  "palette.hint": "↑↓ to move · ↵ to open · esc to close",
  "cmd.newTask": "New task",
  "cmd.newProject": "New project",
  "cmd.cycleTheme": "Switch theme",
  "cmd.settings": "Open settings",
  "cmd.logout": "Log out",
  "cmd.goto": "Go to {name}",

  "members.title": "Members",
  "members.you": "You",
  "members.role.owner": "Owner",
  "members.role.admin": "Admin",
  "members.role.member": "Member",
  "members.role.viewer": "Viewer",
  "members.remove": "Remove",
  "members.leave": "Leave workspace",
  "members.removeConfirm": "Remove {name} from this workspace?",
  "members.leaveConfirm": "Leave this workspace?",
  "members.lastOwner": "A workspace must keep at least one owner.",
  "members.forbidden": "You don't have permission to change this member.",
  "members.pending": "Pending invites",
  "members.noPending": "No pending invites.",
  "members.invite": "Invite people",
  "members.inviteRole": "Role",
  "members.emailOptional": "Email (optional)",
  "members.createLink": "Create invite link",
  "members.revoke": "Revoke",
  "members.copyLink": "Copy link",
  "members.copied": "Link copied",
  "members.expires": "Expires {date}",
  "members.readonlyHint": "You have viewer access — changes are read-only.",

  "invite.title": "You're invited",
  "invite.body": "Join this workspace on Balu.",
  "invite.signInFirst": "Sign in or create an account to join.",
  "invite.accept": "Accept invite",
  "invite.accepting": "Joining…",
  "invite.joined": "Welcome to the workspace",
  "invite.invalidTitle": "Invite not valid",
  "invite.invalidBody": "This link has expired or been revoked. Ask for a fresh one.",
  "invite.back": "Back to Balu",

  "workspace.switch": "Switch workspace",
  "workspace.new": "New workspace",
  "workspace.newName": "Workspace name",
  "workspace.create": "Create",
  "workspace.delete": "Delete workspace",
  "workspace.deletePrompt": "This permanently deletes the workspace with all its projects, tasks and comments. Type the workspace name to confirm.",
  "workspace.deleted": "Workspace deleted",
  "workspace.deleteNameMismatch": "The name did not match.",

  "channels.subtitle": "Where reminders reach you. Configured per account.",
  "channels.add": "Add channel",
  "channels.none": "No channels yet.",
  "channels.type.ntfy": "ntfy",
  "channels.type.email": "Email",
  "channels.type.telegram": "Telegram",
  "channels.ntfyUrl": "ntfy topic URL",
  "channels.emailAddress": "Email address",
  "channels.telegramChatId": "Telegram chat ID",
  "channels.test": "Send test",
  "channels.tested": "Test message sent",
  "channels.unavailable": "This server has no {type} transport configured.",
  "channels.remove": "Remove channel",
  "channels.save": "Save channels",
  "channels.saved": "Channels saved",

  "mcp.subtitle": "Connect Claude Code (or any MCP client) to this server and let it manage your tasks.",
  "mcp.endpoint": "MCP endpoint",
  "mcp.key": "Auth key",
  "mcp.reveal": "Show key",
  "mcp.hide": "Hide key",
  "mcp.hint": "Add it to Claude Code:",
  "mcp.noKey": "No key yet. Generate one to connect a client.",
  "mcp.generate": "Generate key",
  "mcp.generated": "Key generated",
  "mcp.regenerate": "Generate a new key",
  "mcp.regenerateHint": "Anything connected with the old key stops working.",
  "mcp.regenerateConfirm": "Generate a new key? Every client still using the old one loses access immediately.",
  "mcp.regenerated": "New key generated",

  "theme.system": "System",
  "theme.light": "Light",
  "theme.dark": "Dark",

  "auth.loginTitle": "Welcome back",
  "auth.registerTitle": "Create your account",
  "auth.tagline": "the self-hostable todo app.",
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.name": "Name",
  "auth.login": "Log in",
  "auth.register": "Sign up",
  "auth.toRegister": "Need an account? Sign up",
  "auth.toLogin": "Have an account? Log in",
  "auth.rate_limited": "Too many attempts. Please wait a moment and try again.",
  "auth.errorGeneric": "Something went wrong. Please try again.",
  "auth.invalid_credentials": "Wrong email or password.",
  "auth.email_taken": "That email is already registered.",
  "auth.registration_disabled": "Registration is disabled on this server.",

  "project.newProject": "New project",
  "project.newProjectName": "Project name",
  "project.addSection": "Add section",
  "project.sectionName": "Section name",
  "project.deleteSection": "Delete section",
  "project.deleteSectionConfirm": "Delete this section? Its tasks are kept and moved out of the section.",
  "project.actions": "Project actions",
  "project.rename": "Rename",
  "project.color": "Color",
  "project.archive": "Archive",
  "project.unarchive": "Unarchive",
  "project.archived": "Archived",
  "project.archivedSuffix": "(archived)",
  "project.archivedProjects": "Archived projects",
  "project.delete": "Delete project",
  "project.deleteConfirm": "Delete “{name}” and its {count} open tasks? This cannot be undone.",
  "project.deleteConfirmOne": "Delete “{name}” and its 1 open task? This cannot be undone.",
  "project.deleteConfirmEmpty": "Delete “{name}”? This cannot be undone.",

  // Screen-reader announcements for drag & drop; a successful move stays
  // silent otherwise (rejections are reported by sync.rejected).
  "dnd.pickedUp": "Picked up {title}",
  "dnd.projectPickedUp": "Picked up project {name}",
  "dnd.overTarget": "Over {target}",
  "dnd.overGeneric": "Over a list",
  "dnd.droppedTarget": "Moved to {target}",
  "dnd.staleTarget": "That task or its destination no longer exists.",
  "dnd.dropped": "Task dropped",
  "dnd.projectDropped": "Project dropped",
  "dnd.cancelled": "Move cancelled",

  "date.today": "Today",
  "date.tomorrow": "Tomorrow",
  "date.yesterday": "Yesterday",
  "date.overdue": "Overdue",

  "common.cancel": "Cancel",
  "common.later": "Later this week",
  "common.copy": "Copy",
  "common.copied": "Copied",
  "common.confirm": "Confirm",
  "common.remove": "Remove",
} as const;

export type TranslationKey = keyof typeof en;
